import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import AddSocialMedia from '../../core/modals/inventory/addsocialmedia';
import {set_gateway_list} from "../../core/redux/action";
import axios from 'axios';

import { Button, Card } from 'react-bootstrap';

const socialMediaPlatforms = [
    { name: 'Facebook Page', icon: <img src="assets/img/social/facebook-ico.png" alt="Facebook Icon" style={{ width: '20px', height: '20px' }} />, key: 'facebook' }
];

const SocialMedia2 = () => {
    const dispatch = useDispatch();
     //social media new block code
     const [connectedAccounts, setConnectedAccounts] = useState({}); 
    const pageRefresh = useSelector((state) => (state.pageRefresh?.paymentConfigs || 0));
    // const [dataStore, setDataStore] = useState([]);
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");
    // const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        async function fetchData() {
          let result = await axios.get("getsocialmedia/");
          dispatch(set_gateway_list(result.data.socialMedias))
        }
        //  if (!isFetching) {
        //     getStoreApi();
        //   }

        fetchData()
        
      }, [pageRefresh])
      
    //social media new block code

    useEffect(() => {
        axios.get('/api/socialmedia/accounts')
            .then(response => setConnectedAccounts(response.data))
            .catch(error => console.error('Error fetching accounts:', error));
    }, []);

    useEffect(() => {
        // Load Facebook SDK
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: '1678530263053740', // <-- put your real Facebook App ID here
                cookie: true,
                xfbml: true,
                version: 'v22.0'
            });
        };
    
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }, []);
    
    //end social media new block code
    // const dataSource = useSelector((state) => state.gateway_list);
    const permissions = useSelector(state => state.permissions) || [];
    const roleTitle = useSelector(state => state.roleTitle) || '';
    const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';

    const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'view');
  
    if (!canView) {
        return ( 
        <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{t?.[l]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
    )}


    //social media new block code

// Inside your component, replace handleFacebookLogin with this updated version:
const handleFacebookLogin = () => {
    window.FB.login(
        (response) => {
            if (response.authResponse) {
                const { accessToken, userID } = response.authResponse;
                console.log("Logged in User ID:", userID);
                console.log("Access Token:", accessToken);

                // Save token or do something with it
                saveToken('facebook', accessToken);
            } else {
                alert("Facebook login failed or was cancelled.");
            }
        },
        {
            config_id: '694606752955121', // <-- Insert your Facebook config_id here
            scope: 'public_profile,pages_show_list,pages_manage_posts'
        }
    );
};


    const saveToken = async (platform, token) => {
        try {
            // await axios.post('/api/socialmedia/save-token', { platform, token });
            // setConnectedAccounts(prev => ({ ...prev, [platform]: true }));
            console.log("fb token:",token)
            alert(`${platform} connected successfully! ${token}`);
        } catch (error) {
            console.error('Error saving token:', error);
        }
    };
    //end social media new block code
    
    return (
        <div>
            <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
                <div className="content">
                    <Card className="p-3">
                        <Card.Body>
                            <Card.Title>Connect Socials</Card.Title>
                            <Card.Text>Connect your social media accounts to allow Marky to post on your behalf.</Card.Text>
                            <div className="list-group">
                                {socialMediaPlatforms.map(({ name, icon, key }) => (
                                    <div key={key} className="d-flex justify-content-between align-items-center border-bottom p-2">
                                        <div className="d-flex align-items-center">
                                            <span className="me-2" style={{ fontSize: '20px' }}>{icon}</span>
                                            <span>{name}</span>
                                        </div>
                                        {connectedAccounts[key] ? (
                                            <Button variant="success" disabled>Connected</Button>
                                        ) : (
                                            <Button variant="primary" onClick={() => key === 'facebook' ? handleFacebookLogin() : null}>
                                                Connect
                                            </Button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>
            <AddSocialMedia />
        </div>
    )
}

export default SocialMedia2;